export default __webpack_public_path__ + "static/media/NotoSans-Medium.0fbf0f28.ttf";